// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + ({"1465":"f5cf3357","9910":"a4634e51"}[chunkId] || chunkId) + "." + {"1465":"bcddf98f9a896027","5136":"7887c77492e2a612","5376":"2ff82d5f5063c11b","6521":"92122038a6ae399a","6718":"dc2ba230e3f3335a","8842":"2a7a60b834df133b","9910":"5084ed39a62c55a7"}[chunkId] + ".js";
};